export class SessionProviderDelegate {
    canvasNeeded: any = null;
    retireCanvas: any = null;
    monitorBounds: any = null;
}
